<script>
import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'
import Adminpay24DepositDetails from './Adminpay24DepositDetails.vue'

const API = 'https://apifront.spin-up.co/adminpay24'
export default {
  name: 'Adminpay24Deposit',
  components: { Adminpay24DepositDetails },
  props: {
    request: { type: Object, required: true },
  },
  data() {
    return { deposit: null, error: '', busy: false, timer: null, disposed: false, slipOpened: false }
  },
  computed: {
    terminal() {
      return this.deposit && ['EXPIRED', 'CANCELLED', 'REFUNDED'].includes(this.deposit.status)
    },
  },
  mounted() {
    window.addEventListener('focus', this.checkAfterSlip)
    document.addEventListener('visibilitychange', this.checkAfterSlip)
    this.load()
  },
  beforeDestroy() {
    this.disposed = true
    clearTimeout(this.timer)
    window.removeEventListener('focus', this.checkAfterSlip)
    document.removeEventListener('visibilitychange', this.checkAfterSlip)
  },
  methods: {
    checkAfterSlip() {
      if (this.slipOpened && this.deposit && !this.deposit.successful && !document.hidden) this.load()
    },
    async load() {
      if (this.busy || this.disposed) return
      clearTimeout(this.timer)
      this.busy = true
      this.error = ''
      try {
        const user = firebase.auth().currentUser
        if (!user) throw new Error('กรุณาเข้าสู่ระบบใหม่อีกครั้ง')
        const token = await user.getIdToken()
        const config = { headers: { Authorization: `Bearer ${token}` }, timeout: 60000 }
        const response = this.deposit
          ? await axios.get(`${API}/deposit/${encodeURIComponent(this.deposit.id)}`, config)
          : await axios.post(`${API}/deposit`, this.request, config)
        if (this.disposed) return
        this.deposit = response.data
        if (this.deposit.successful) { this.$emit('paid'); return }
      } catch (error) {
        if (this.disposed) return
        this.error = (error.response && error.response.data && error.response.data.message) || 'ไม่สามารถตรวจสอบรายการได้ กรุณาลองตรวจสอบอีกครั้ง'
      } finally {
        this.busy = false
        if (!this.disposed) this.$emit('ready')
      }
      if (!this.disposed && this.deposit && !this.terminal) this.timer = setTimeout(() => this.load(), 10000)
    },
  },
}
</script>

<template>
  <Adminpay24DepositDetails :deposit="deposit" :busy="busy" :error="error"
    @check="load" @attach-slip="slipOpened = true" @restart="$emit('restart')" />
</template>
